import { RefString, Snack } from "@tblabs/truffle";
import { AdminStepPrinter } from "../../../Components/AdminStepPrinter";
import { Center } from "../../../Components/Utils/Center";
import { OrdersManager } from "../../../Services/Storage/OrdersManager";
import { Router } from "../../../Services/Router";
import { StepsPrinter } from "../../../Components/StepsPrinter";
import { OrderEventsCalendar } from "../../../Components/OrderEventsCalendar";
import { PeoplePrinter } from "./Components/PeoplePrinter";
import { TabsV2 } from "../../../Components/Utils/Tabs";
import { AgentsProvider } from "../../../Services/Agents/AgentsProvider";
import { OrderHeader } from "./Components/OrderHeader";
import { Icons } from "../../../Components/Utils/Icons";
import { MoneyList } from "../OrdersView/Views/Table/Components/MoneyList";
import { OrderNotes } from "../OrdersView/Views/Table/Components/OrderNotes";
import { BasketInfo } from "./Components/BasketInfo";
import { Page } from "../../Page";
import { InfoBox } from "../../Customer/InfoBox";


export class AdminOrderViewPage extends Page
{
    // private CHAT_ENABLED = false;
    constructor(
        private _manager: OrdersManager,
        private _router: Router,
        private _agents: AgentsProvider,
        private orderId: string)
    {
        super(`Zamówienie #${orderId}`);

        this.Content(async (body) =>
        {
            const order = await this._manager.GetOne(this.orderId);

            if (!order)
            {
                body.Append(
                    new Center(new InfoBox("Błąd", `Nie znaleziono zamówienia. Jego adres jest niepoprawny lub zostało zamknięte albo usunięte.`)));
                return;
            }

            order.OnChange(async () => 
            {
                const result = await this._manager.Update(order);

                new Snack("✅ Zmiany zapisane", result.NotificationHasBeenSent ? "✉️ Powiadomienie wysłane" : "Bez powiadomienia");
            });

            const view = new RefString("Przebieg").Storable("admin-order-view");

            const tabs = new TabsV2(view)
                .Add(Icons.Basket, "Koszyk", () => new BasketInfo(order))
                .Add(Icons.Route, "Przebieg", () => new StepsPrinter(order.Steps.Items, "admin", (step) => new AdminStepPrinter(this._router, this._agents, step), true))
                .Add(Icons.Calendar, "Kalendarz", () => new OrderEventsCalendar(order).MarginTop(32))
                .Add(Icons.User, "Ludzie", () => new PeoplePrinter(order.People))
                .Add(Icons.Money, "Rozliczenie", () => new MoneyList(order))
                .Add(Icons.Notes, "Notatki" + (order.AreAnyNotes ? "🔴" : ""), () => new OrderNotes(order))
            /*
                     if (this.CHAT_ENABLED)
                    {
                        const _connector = new RemoteStorageChatConnector(this._messageBus, order.Id);
                        const chat = new Chat(_connector, new ChatUser({ Name: this._auth.UserInfo?.User?.ChatName || "Admin" }));
            
                        await _connector.Load();
            
                        tabs.Add(Icons.Chat, `Czat${chat.IsUnread ? "🔴" : ""}`, () => new ChatView(chat))
                    }
            */
            body.Append(
                new OrderHeader(this._router, this._manager, order).MarginTop(16).MarginBottom(16),
                tabs,
            );
        });
    }
}
